var _rect, _rect2, _line, _line2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _text, _text2, _text3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path, _rect27, _rect28, _path2, _rect29, _rect30, _path3, _circle4, _text4, _line3, _circle5, _circle6, _circle7, _circle8, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectsHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 190,
    height: 138,
    rx: 8,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 174,
    height: 122,
    rx: 4,
    fill: "rgba(255,255,255,0.06)",
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 123,
    y1: 156,
    x2: 123,
    y2: 174,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 174,
    x2: 150,
    y2: 174,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 174,
    height: 16,
    rx: 4,
    fill: "rgba(255,255,255,0.15)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 36,
    r: 3,
    fill: "rgba(255,255,255,0.45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 36,
    r: 3,
    fill: "rgba(255,255,255,0.45)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 36,
    r: 3,
    fill: "rgba(255,255,255,0.45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 50,
    width: 54,
    height: 12,
    rx: 3,
    fill: "rgba(255,255,255,0.2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 50,
    width: 54,
    height: 12,
    rx: 3,
    fill: "rgba(255,255,255,0.22)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 50,
    width: 54,
    height: 12,
    rx: 3,
    fill: "rgba(255,255,255,0.2)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 59,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 6.5,
    fill: "rgba(255,255,255,0.85)",
    fontWeight: 600
  }, "To Do")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 59,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 6.5,
    fill: "rgba(255,255,255,0.85)",
    fontWeight: 600
  }, "In Progress")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 59,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 6.5,
    fill: "rgba(255,255,255,0.85)",
    fontWeight: 600
  }, "Done")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 68,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 74,
    width: 36,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.55)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 81,
    width: 26,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.3)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 100,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 106,
    width: 30,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.55)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 113,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.3)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 68,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.16)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 74,
    width: 40,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.8)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 81,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.45)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 87,
    width: 44,
    height: 3.5,
    rx: 1.8,
    fill: "rgba(255,255,255,0.18)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 87,
    width: 28,
    height: 3.5,
    rx: 1.8,
    fill: "rgba(255,255,255,0.75)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 100,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.16)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 106,
    width: 34,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.8)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 113,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "rgba(255,255,255,0.45)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 119,
    width: 44,
    height: 3.5,
    rx: 1.8,
    fill: "rgba(255,255,255,0.18)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 119,
    width: 38,
    height: 3.5,
    rx: 1.8,
    fill: "rgba(255,255,255,0.75)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 132,
    width: 54,
    height: 18,
    rx: 3,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 138,
    width: 28,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.7)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 68,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.07)",
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 74,
    width: 32,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 84 L190 87 L196 80",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 100,
    width: 54,
    height: 26,
    rx: 3,
    fill: "rgba(255,255,255,0.07)",
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 106,
    width: 28,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187 116 L190 119 L196 112",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 132,
    width: 54,
    height: 18,
    rx: 3,
    fill: "rgba(255,255,255,0.07)",
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 138,
    width: 24,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187 144 L190 147 L196 141",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 70,
    r: 20,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 66,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "rgba(255,255,255,0.85)",
    fontWeight: 700
  }, "AI")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 285,
    y1: 74,
    x2: 300,
    y2: 82,
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1,
    strokeDasharray: "3 3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 130,
    r: 16,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.55)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 126,
    r: 3,
    fill: "rgba(255,255,255,0.7)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 126,
    r: 3,
    fill: "rgba(255,255,255,0.7)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 136,
    r: 3,
    fill: "rgba(255,255,255,0.85)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 126,
    x2: 270,
    y2: 136,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 276,
    y1: 126,
    x2: 270,
    y2: 136,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 264,
    y1: 126,
    x2: 276,
    y2: 126,
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 87,
    x2: 250,
    y2: 70,
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 1,
    strokeDasharray: "3 4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 222,
    y1: 107,
    x2: 254,
    y2: 130,
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 1,
    strokeDasharray: "3 4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsHero);
export default __webpack_public_path__ + "static/media/projects_hero.92f5087ed692eabfeec257735e083295.svg";
export { ForwardRef as ReactComponent };